class GetRubros {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    const rubros = await this.#repository.getRubros()
    return rubros
  }
}

export default GetRubros
